<i18n>
{
	"en": {
		"InputTodoName": "Input todo name"
	},
	"vi": {
		"InputTodoName": "Nhập công việc..."
	}
}
</i18n>

<template>
	<div class="add-checklist" id="checklist-loading">
		<h6 class="mb-2 custom-component--title" v-if="title && title !== ''">{{ title }}:</h6>
		<draggable :list="checklist">
			<transition-group>
				<div
					@click="onClickItem(index)"
					class="list-item flex justify-between items-center add-checklist--item"
					v-bind:class="{ 'add-checklist--focus-item': focusItem === index }"
					v-for="(listItem, index) in checklist"
					:key="`checklist-item-${index}`"
				>
					<div class="flex items-center">
						<i
							@click="checkDone(listItem.id)"
							v-if="parentTodoId && todoType === $constant.TODO_TYPE.NORMAL && !disabledCheckDone"
							:class="['nucleo mr-1 text-2xl', checkboxes[listItem.id] || listItem.done_at ? 'nucleo-ic_check_box_24px' : 'nucleo-ic_check_box_outline_blank_24px']"
						></i>
						<vs-checkbox v-else-if="listItem.done_at" v-model="checked" :disabled="true" color="primary" />
						<vs-checkbox v-else :disabled="true" color="primary" />
						<p v-html="listItem.title" class="contenteditable" :contenteditable="canEdit" @focusout="onChangeCurrentItem(index, $event)" v-if="parentTodoId && listItem.title"></p>

						<p v-html="listItem" class="contenteditable" :contenteditable="canEdit" @focusout="onChangeCurrentItem(index, $event)" v-else></p>
					</div>
					<vs-button
						@click="deleteItem(index)"
						v-if="focusItem === index && canEdit && !checkboxes[listItem.id]"
						class="p-0"
						radius
						color="primary"
						type="flat"
						icon-pack="nucleo"
						icon="nucleo-trash-can"
					></vs-button>
				</div>
			</transition-group>
		</draggable>
		<form v-if="canEdit" @submit.prevent="addNewChecklist" autocomplete="off">
			<vs-input icon-no-border icon="nucleo-ic_check_box_outline_blank_24px" icon-pack="nucleo" v-model="item" class="w-full mt-0" :placeholder="$t(placeHolder)" />
		</form>
	</div>
</template>

<script>
import draggable from "vuedraggable";
export default {
	components: {
		draggable
	},
	props: {
		title: {
			type: String,
			default: "Checklist"
		},
		placeHolder: {
			type: String,
			default: "InputTodoName"
		},
		disabledCheckDone: {
			type: Boolean,
			default: true
		},
		defaultChecklist: {
			type: Array,
			default: () => []
		},
		canEdit: {
			type: Boolean,
			default: true
		},
		parentTodoId: {
			type: Number
		},
		todoType: { type: Number }
	},
	data() {
		return {
			item: "",
			checklist: this.defaultChecklist,
			focusItem: -1,
			checked: true
		};
	},
	methods: {
		addNewChecklist() {
			if (this.item.trim().length > 0) {
				if (this.parentTodoId) {
					this.openLoading();
					this.$store
						.dispatch("todoListManagement/addCheckListItem", { title: this.item, todolist_id: this.parentTodoId })
						.then(res => {
							this.checklist.push(res);
							this.closeLoading();
						})
						.catch(() => {
							this.closeLoading();
						});
				} else {
					this.checklist.push(this.item);
				}
				this.item = "";
			}
		},
		onClickItem(index) {
			this.focusItem = this.focusItem === index ? -1 : index;
		},
		deleteItem(index) {
			if (this.parentTodoId) {
				this.openLoading();
				this.$store
					.dispatch("todoListManagement/deleteCheckListItem", { id: this.checklist[index].id })
					.then(() => {
						this.checklist.splice(index, 1);
						this.closeLoading();
					})
					.catch(() => {
						this.closeLoading();
					});
			} else {
				this.checklist.splice(index, 1);
			}
		},
		onChangeCurrentItem(index, e) {
			const inputValue = e.target.innerText;
			if (this.parentTodoId) {
				if (inputValue === this.checklist[index].title) return;
				this.checklist[index].title = inputValue;
				this.$store.dispatch("todoListManagement/updateCheckListItem", { id: this.checklist[index].id, title: this.checklist[index].title });
			} else {
				this.checklist[index] = inputValue;
			}
		},
		openLoading() {
			this.$vs.loading({
				container: "#checklist-loading",
				scale: 0.6
			});
		},
		closeLoading() {
			this.$vs.loading.close("#checklist-loading > .con-vs-loading");
		},
		checkDone(id) {
			if (this.todoType === this.$constant.TODO_TYPE.NORMAL) {
				this.checkboxes[id] = !this.checkboxes[id];
				this.$store.dispatch("todoListManagement/checkDoneCheckListItem", { id: id, isDone: this.checkboxes[id] });
			}
		}
	},
	watch: {
		checklist() {
			this.$emit("emitNewChecklist", this.checklist);
		},
		defaultChecklist() {
			this.checklist = this.defaultChecklist;
		}
	},
	computed: {
		checkboxes() {
			let ArrayCheckboxes = [];
			this.checklist.map(item => {
				if (item.done_at) {
					ArrayCheckboxes[item.id] = true;
				} else {
					ArrayCheckboxes[item.id] = false;
				}
			});
			return ArrayCheckboxes;
		}
	},
	destroyed() {
		this.checklist = [];
	}
};
</script>

<style lang="scss">
.add-checklist {
	.vs-con-input {
		input {
			height: auto;
			padding-left: 48px !important;
		}
		i {
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			margin-left: 10px;
			font-size: 21px;
			color: #828282;
		}
		.vs-input--placeholder {
			padding-left: 48px !important;
		}
	}
}
.add-checklist--item {
	background: #ffffff;
	border: 1px solid #f2f2f2;
	box-sizing: border-box;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
	border-radius: 4px;
	margin: 8px 0;
	padding: 0 10px;
	min-height: 38px;
}
.add-checklist--focus-item {
	background: #f5f5f5;
}
.list-item,
[dir] .list-item {
	transition: all 0.4s;
	&:hover {
		cursor: pointer;
	}
}

.contenteditable br {
	display: none !important;
}
</style>
